import {useEffect} from 'react';
import {changeHeaderTitle} from 'app/actions/headerActions';
import {useDispatch} from 'react-redux';

export const useAppBarTitle = (title: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(changeHeaderTitle(title));
  }, [dispatch, title]);
};
